import axios from "axios";
import api, { APIClient } from "../api";
import {
    GraphModel, InstalledPatchDataModel, MissingPatchDataModel, PatchDataModel,
    PatchModel, SystemByPlataformList, SystemModel, TopPriorityPatchDataModel
} from "./patchManagerModel";


export class PatchManagerService extends APIClient {
    constructor(props: any) {
        super(props);
    }

    getPatches = async (): Promise<PatchModel> => {
        debugger;
        const url = `${this.endpoint}/api/PatchManager/GetPatchesResume`;
        var result = (await api({
            method: 'get',
            url,
        })).data;
        return result;
        /*

       return {
           "patches": 5,
           "failures": 2,
           "critics": 3
       } as PatchModel;*/
    }
    GetPatchSummariesResume = async (): Promise<GraphModel[]> => {
        debugger;
        const url = `${this.endpoint}/api/PatchManager/GetPatchSummariesResume`;
        var result = (await api({
            method: 'get',
            url,
        })).data;
        return result;
        /*

       return {
           "patches": 5,
           "failures": 2,
           "critics": 3
       } as PatchModel;*/
    }

    getSystemInfos = async (): Promise<SystemModel> => {

        const url = `${this.endpoint}/api/PatchManager/getSystemInfos`;
        var result = (await api({
            method: 'get',
            url,
        })).data;
        return result;
        /*   return {
               "systems": 15,
               "pendentReboot": 5,
               "agent": 10
           } as SystemModel;*/
    }

    getPatchesInfo = async (): Promise<GraphModel[]> => {

        const url = `${this.endpoint}/api/PatchManager/GetPathesInfo`;
        var result = (await api({
            method: 'get',
            url,
        })).data;
        return result;
        /*   return [
               {
                   "value": 20,
                   "name": "Stability Improvements",
                   "color": "#c4342d"
               },
           ]*/
    }   
    GetPatchSummariesInstalledVsMissing = async (): Promise<GraphModel[]> => {

        const url = `${this.endpoint}/api/PatchManager/GetPatchSummariesInstalledVsMissing`;
        var result = (await api({
            method: 'get',
            url,
        })).data;
        return result;
        /*   return [
               {
                   "value": 20,
                   "name": "Stability Improvements",
                   "color": "#c4342d"
               },
           ]*/
    }
    GetPatchSummariesMissingSeverity = async (): Promise<GraphModel[]> => {

        const url = `${this.endpoint}/api/PatchManager/GetPatchSummariesMissingSeverity`;
        var result = (await api({
            method: 'get',
            url,
        })).data;
        return result;
        /*   return [
               {
                   "value": 20,
                   "name": "Stability Improvements",
                   "color": "#c4342d"
               },
           ]*/
    }

    GetMissingPatches = async (): Promise<GraphModel[]> => {
        /* 'Crítico':'#dc291e',
        'Importante': "#ffa400",
        'Moderado': "#f6de00",
        'Baixo': "#3ebb3f",
        'Não classificado': "#cccccf", */
        const url = `${this.endpoint}/api/PatchManager/GetMissingPatches`;
        var result = (await api({
            method: 'get',
            url,
        })).data;
        return result;
        /*  return [
              {
                  "value": 35,
                  "name": "Crítico",
                  "color": "#c4342d"
              },
              {
                  "value": 20,
                  "name": "Importante",
                  "color": "#34F"
              },
              {
                  "value": 15,
                  "name": "Moderado",
                  "color": "#3F4"
              },
          ]*/

    }

    GetSystemByPlatformSupported = async (): Promise<GraphModel[]> => {
     
        const url = `${this.endpoint}/api/PatchManager/GetSystemByPlatformSupported`;
        var result = (await api({
            method: 'get',
            url,
        })).data;
        return result;
        /*   return [
   
               {
                   "value": 40,
                   "name": "Windows Server",
                   "color": "#ffa500"
               },
               {
                   "value": 5,
                   "name": "Linux",
                   "color": "#663399"
               }
           ]*/
    }

    GetSystemByPlatformObsolete = async (systems: Array<string>): Promise<GraphModel[]> => {
       
        const url = `${this.endpoint}/api/PatchManager/GetSystemByPlatformObsolete`;
        var result = (await api({
            method: 'get',
            url,
        })).data;
        return result;
     /*   const obsoletedSystems: any = [];
        for (const so of systems) {
            const url = `https://endoflife.date/api/${so}.json`;

            try {
                const resp = await api({
                    method: 'get',
                    url,
                });
                obsoletedSystems.push({
                    name: so,
                    value: resp.data.length
                });
            } catch (error: any) {
                console.error(`Erro ao obter informações para ${so}: ${error.message}`);
            }
        }
        return obsoletedSystems;*/

        /* return [
             {
                 "value": 100,
                 "name": "windows",
                 "color": "#c4342d"
             },
             {
                 "value": 200,
                 "name": "windows-server",
                 "color": "#1b457e"
             },
             {
                 "value": 150,
                 "name": "linux",
                 "color": "#32cd32"
             }
         ]*/
    }

    GetSystemByPlatformList = async (): Promise<SystemByPlataformList[]> => {

        const url = `${this.endpoint}/api/PatchManager/GetSystemByPlatformList`;
        var result = (await api({
            method: 'get',
            url,
        })).data;
        return result;
        /*   return [
               {
                   "hostName": "Server001",
                   "agent_Status": "Active",
                   "agent_Installation": "2023-04-15",
                   "last_Communication": "2023-11-16",
                   "reboot_Required": false,
                   "legacy_system": true,
                   "operational_System": "Windows Server 2016",
                   "SO_language": "English",
                   "IP": ["192.168.1.10", "10.0.0.1"],
                   "missing_Patches": [
                       {
                           "patch_Id": 1001,
                           "report_Card": "Critical",
                           "severity": "High",
                           "patch_Description": "Security update for kernel vulnerabilities",
                           "manufacturer": "Microsoft",
                           "type_Patch": "Security",
                           "status": "Pending",
                           "Instalation_Date": "Not installed",
                           "patch_File": "KB1001.exe",
                           "legacy": false
                       },
                       {
                           "patch_Id": 1002,
                           "report_Card": "Important",
                           "severity": "Medium",
                           "patch_Description": "Update for system stability improvements",
                           "manufacturer": "Microsoft",
                           "type_Patch": "Maintenance",
                           "status": "Pending",
                           "Instalation_Date": "Not installed",
                           "patch_File": "KB1002.exe",
                           "legacy": false
                       }
                   ]
               },
               {
                   "hostName": "Server002",
                   "agent_Status": "Inactive",
                   "agent_Installation": "2023-03-11",
                   "last_Communication": "2023-11-10",
                   "reboot_Required": true,
                   "legacy_system": false,
                   "operational_System": "Ubuntu 20.04",
                   "SO_language": "English",
                   "IP": ["192.168.1.20", "10.0.0.2"],
                   "missing_Patches": [
                       {
                           "patch_Id": 2001,
                           "report_Card": "Moderate",
                           "severity": "Low",
                           "patch_Description": "Minor bug fixes and performance enhancements",
                           "manufacturer": "Canonical",
                           "type_Patch": "Bug Fix",
                           "status": "Pending",
                           "Instalation_Date": "Not installed",
                           "patch_File": "patch2001.deb",
                           "legacy": false
                       }
                   ]
               }
           ]*/
    }

    GetPatchesData = async (): Promise<PatchDataModel[]> => {
        try {
            debugger;
            const url = `${this.endpoint}/api/PatchManager/GetPatchesData`;
            var result = (await api({
                method: 'get',
                url,
            })).data;
            return result;
        } catch (e) {
            debugger;
        }
        return [] as unknown as PatchDataModel[];
        /*    return [
                {
                    "patch_Id": 50123,
                    "kb_number": "KB50123",
                    "patch_Description": "Security update for critical vulnerabilities in network components",
                    "patch_Name": "Network Security Update",
                    "severity": "Critical",
                    "plataform": "Windows",
                    "missing_system": 12,
                    "installed_Systems": 48,
                    "failed_system": 3,
                    "report_Card": "High Priority",
                    "approve_Status": "Approved",
                    "systems_detail": [
                        {
                            "computer_name": "WS-001",
                            "domain": "corp.example.com",
                            "operating_system": "Windows 10",
                            "patch_id": 50123,
                            "patch_status": "Installed",
                            "patch_serverity": "Critical"
                        },
                        {
                            "computer_name": "WS-002",
                            "domain": "corp.example.com",
                            "operating_system": "Windows 10",
                            "patch_id": 50123,
                            "patch_status": "Failed",
                            "patch_serverity": "Critical"
                        }
                    ]
                },
                {
                    "patch_Id": 60234,
                    "kb_number": "KB60234",
                    "patch_Description": "Update for performance improvements in file system operations",
                    "patch_Name": "File System Performance Update",
                    "severity": "Moderate",
                    "plataform": "Linux",
                    "missing_system": 8,
                    "installed_Systems": 30,
                    "failed_system": 1,
                    "report_Card": "Medium Priority",
                    "approve_Status": "Pending Approval",
                    "systems_detail": [
                        {
                            "computer_name": "LX-101",
                            "domain": "dev.example.com",
                            "operating_system": "Ubuntu 20.04",
                            "patch_id": 60234,
                            "patch_status": "Pending",
                            "patch_serverity": "Moderate"
                        },
                        {
                            "computer_name": "LX-102",
                            "domain": "dev.example.com",
                            "operating_system": "Ubuntu 20.04",
                            "patch_id": 60234,
                            "patch_status": "Installed",
                            "patch_serverity": "Moderate"
                        }
                    ]
                }
            ]*/
    }

    GetMissingPatchesData = async (): Promise<MissingPatchDataModel[]> => {
        /*   return [
               {
                   "patch_Id": 78124,
                   "kb_number": "KB78124",
                   "patch_Description": "Critical security update for remote code execution vulnerability",
                   "severity": "Critical",
                   "plataform": "Windows Server",
                   "missing_system": 15,
                   "failed_system": 2,
                   "systems_detail": [
                       {
                           "computer_name": "Server01",
                           "domain": "internal.company.com",
                           "operating_system": "Windows Server 2019",
                           "patch_id": 78124,
                           "patch_status": "Missing",
                           "patch_serverity": "Critical"
                       },
                       {
                           "computer_name": "Server02",
                           "domain": "internal.company.com",
                           "operating_system": "Windows Server 2016",
                           "patch_id": 78124,
                           "patch_status": "Failed",
                           "patch_serverity": "Critical"
                       }
                   ]
               },
               {
                   "patch_Id": 45201,
                   "kb_number": "KB45201",
                   "patch_Description": "Update for system stability and performance improvements",
                   "severity": "Moderate",
                   "plataform": "Linux",
                   "missing_system": 10,
                   "failed_system": 1,
                   "systems_detail": [
                       {
                           "computer_name": "LinuxServer03",
                           "domain": "devops.company.com",
                           "operating_system": "Ubuntu 18.04",
                           "patch_id": 45201,
                           "patch_status": "Missing",
                           "patch_serverity": "Moderate"
                       },
                       {
                           "computer_name": "LinuxServer04",
                           "domain": "devops.company.com",
                           "operating_system": "Debian 10",
                           "patch_id": 45201,
                           "patch_status": "Missing",
                           "patch_serverity": "Moderate"
                       }
                   ]
               }
           ];*/
        const url = `${this.endpoint}/api/PatchManager/GetMissingPatchesData`;
        var result = (await api({
            method: 'get',
            url,
        })).data;
        return result;
    }

    GetInstalledPatchesData = async (): Promise<InstalledPatchDataModel[]> => {
        /* return [
             {
                 "patch_Id": 99512,
                 "patch_Name": "Critical Network Security Patch",
                 "severity": "High",
                 "plataform": "Windows",
                 "installed_Systems": 25,
                 "installed_systems_detail": [
                     {
                         "computer_name": "OfficePC-01",
                         "domain": "network.company.com",
                         "operating_system": "Windows 10 Pro",
                         "patch_id": 99512,
                         "patch_status": "Installed",
                         "patch_serverity": "High"
                     },
                     {
                         "computer_name": "OfficePC-02",
                         "domain": "network.company.com",
                         "operating_system": "Windows 10 Pro",
                         "patch_id": 99512,
                         "patch_status": "Installed",
                         "patch_serverity": "High"
                     }
                 ]
             },
             {
                 "patch_Id": 67845,
                 "patch_Name": "Linux Kernel Update",
                 "severity": "Medium",
                 "plataform": "Linux",
                 "installed_Systems": 15,
                 "installed_systems_detail": [
                     {
                         "computer_name": "DevServer-101",
                         "domain": "dev.company.com",
                         "operating_system": "Ubuntu 20.04",
                         "patch_id": 67845,
                         "patch_status": "Installed",
                         "patch_serverity": "Medium"
                     },
                     {
                         "computer_name": "DevServer-102",
                         "domain": "dev.company.com",
                         "operating_system": "Debian 10",
                         "patch_id": 67845,
                         "patch_status": "Installed",
                         "patch_serverity": "Medium"
                     }
                 ]
             }
         ]*/
        const url = `${this.endpoint}/api/PatchManager/GetInstalledPatchesData`;
        var result = (await api({
            method: 'get',
            url,
        })).data;
        return result;
    }

    GetTopPriorityPatchesData = async (): Promise<TopPriorityPatchDataModel[]> => {
        /*  return [
              {
                  "patch_Id": 44231,
                  "patch_Description": "Urgent security patch for critical vulnerability in SSL encryption",
                  "severity": "Critical",
                  "missing_system": 18,
                  "failed_system": 4,
                  "report_Card": "Urgent Action Required",
                  "approve_Status": "Approved",
                  "top_priority_systems_detail": [
                      {
                          "computer_name": "FinancePC-01",
                          "domain": "finance.company.com",
                          "operating_system": "Windows 10 Pro",
                          "patch_id": 44231,
                          "patch_status": "Missing",
                          "patch_serverity": "Critical"
                      },
                      {
                          "computer_name": "HRServer-02",
                          "domain": "hr.company.com",
                          "operating_system": "Windows Server 2019",
                          "patch_id": 44231,
                          "patch_status": "Failed",
                          "patch_serverity": "Critical"
                      }
                  ]
              },
              {
                  "patch_Id": 56342,
                  "patch_Description": "Emergency update for data leak vulnerability",
                  "severity": "High",
                  "missing_system": 22,
                  "failed_system": 3,
                  "report_Card": "Immediate Attention Needed",
                  "approve_Status": "Approved",
                  "top_priority_systems_detail": [
                      {
                          "computer_name": "DataCenterVM-05",
                          "domain": "datacenter.company.com",
                          "operating_system": "Ubuntu 18.04",
                          "patch_id": 56342,
                          "patch_status": "Missing",
                          "patch_serverity": "High"
                      },
                      {
                          "computer_name": "WebServer-03",
                          "domain": "web.company.com",
                          "operating_system": "CentOS 7",
                          "patch_id": 56342,
                          "patch_status": "Failed",
                          "patch_serverity": "High"
                      }
                  ]
              }
          ];*/
        const url = `${this.endpoint}/api/PatchManager/GetTopPriorityPatchesData`;
        var result = (await api({
            method: 'get',
            url,
        })).data;
        return result;
    }

}